import { Discipline, DisciplineType } from '@/lib/types';

import { routes } from '@/utils/route-utils';

export function buildCanonicalLink(
  slugs: (string | undefined)[] | string[] | string | undefined
): string {
  let canonicalLink = `${routes.domain()}/`;

  if (!slugs) {
    return canonicalLink;
  }

  let path = '';
  if (Array.isArray(slugs)) {
    path = slugs.join('/');
  } else {
    path = slugs;
  }

  // home is slug is translated to / in web-app rewrite, so we dont want to add the url
  if (path !== 'home') {
    canonicalLink = canonicalLink + path;
  }

  return canonicalLink;
}

export function buildJobCanonicalLinkFromDiscipline(discipline: Discipline) {
  const isNurse = discipline.disciplineType === DisciplineType.Nurse;

  const rawPieces: (string | undefined)[] = [];

  if (isNurse) {
    rawPieces.push('nurse', 'travel-nurse');
  } else {
    rawPieces.push('allied', 'travel-allied', discipline.slug);
  }

  const pieces = rawPieces.filter(
    <T>(piece: T | undefined): piece is T => !!piece
  );
  return `/healthcare-jobs/${pieces.join('/')}`;
}
